import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const ErrorsBlockStyled = styled.ul.attrs<IStyledAttributes>({
  "data-e2e": "rides-modal-errors-block",
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 24px;

  .saved {
    color: ${rydeColors.green};
  }
`;
